// helpers
import addCommas from "helpers/addCommasToNumber";
import parseHTML from "helpers/parseHTML";

// assets
import { SvgClubInfinitumLogo } from "assets/icons/js/SvgClubInfinitumLogo";
import { SvgScissor } from "assets/icons/js/SvgScissor";

// style
import { copyToClipboard } from "helpers/copyToClipboard";
import { useState } from "react";
import "./style.scss";

const ListingCouponCard = ({ item, checkin, checkout }: any) => {
	const [isCopied, setIsCopied] = useState(false);

	const copyToClipboardHandler = (couponCode: string): void => {
		// handle multiple clicks
		if (isCopied) return;
		// set state to true
		// this is to show a que tip that the text has been copied
		// to clipboard
		setIsCopied(true);
		// copy to clip board
		copyToClipboard(couponCode);
		// revert state back to false after 2.5 seconds
		setTimeout(() => {
			setIsCopied(false);
		}, 2000);
	};

	return (
		<div className="coupon-card" key={item.COUPON_ID}>
			<span className="card-img">
				<SvgClubInfinitumLogo />
			</span>
			<div className="card-details">
				<div className="details">
					<p className="title">{parseHTML(item.DESCRIPTION)}</p>
					<p className="subtitle">*{item.TNC ? parseHTML(item.TNC) : ""}</p>
					{item.isApplicable ? (
						<span className="coupon-code applied">
							<SvgScissor />
							{item.COUPON_CODE}
						</span>
					) : null}
				</div>
				{item.isApplicable ? (
					<div className="apply">
						<div className="save-upto">Save ₹{addCommas(item?.discount)}</div>
						<button
							className="active"
							onClick={() => copyToClipboardHandler(item.COUPON_CODE)}
						>
							{isCopied ? "Copied" : "Copy"}
						</button>
					</div>
				) : (
					<div className="not-applicable">
						{checkin && checkout
							? "Not applicable"
							: "Select dates to see discount"}
					</div>
				)}
			</div>
		</div>
	);
};

export default ListingCouponCard;
